import styles from './AuthForm.module.css';

export function MailIcon(): React.JSX.Element {
  return (
    <svg className={styles.inputIcon} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path
        fill="currentColor"
        d="M4 6.5A2.5 2.5 0 0 1 6.5 4h11A2.5 2.5 0 0 1 20 6.5v11a2.5 2.5 0 0 1-2.5 2.5h-11A2.5 2.5 0 0 1 4 17.5v-11Zm2.05-.5 5.45 4.36a1 1 0 0 0 1.2 0L18.2 6H6.05ZM18 8.03l-5.74 4.59a2.5 2.5 0 0 1-3.02 0L3.5 8.03V17.5c0 .55.45 1 1 1h15c.55 0 1-.45 1-1V8.03Z"
      />
    </svg>
  );
}

export function LockIcon(): React.JSX.Element {
  return (
    <svg className={styles.inputIcon} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path
        fill="currentColor"
        d="M8 10V8a4 4 0 1 1 8 0v2h1.5A1.5 1.5 0 0 1 19 11.5v9A1.5 1.5 0 0 1 17.5 22h-11A1.5 1.5 0 0 1 5 20.5v-9A1.5 1.5 0 0 1 6.5 10H8Zm2 0h4V8a2 2 0 1 0-4 0v2Z"
      />
    </svg>
  );
}

export function EyeIcon({ open }: { open: boolean }): React.JSX.Element {
  if (open) {
    return (
      <svg className={styles.toggleIcon} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path
          fill="currentColor"
          d="M12 5c5.2 0 9.3 3.4 10.8 8-1.5 4.6-5.6 8-10.8 8S2.7 17.6 1.2 13C2.7 8.4 6.8 5 12 5Zm0 3a5 5 0 1 0 0 10 5 5 0 0 0 0-10Zm0 2.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5Z"
        />
      </svg>
    );
  }

  return (
    <svg className={styles.toggleIcon} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path
        fill="currentColor"
        d="M3.3 4.7 4.7 3.3 20.7 19.3l-1.4 1.4-2.2-2.2C15.8 19.4 14 20 12 20 6.8 20 2.7 16.6 1.2 12c.7-2.1 2-3.9 3.7-5.2L3.3 4.7ZM12 7c4.1 0 7.5 2.6 8.8 6.2-.6 1.8-1.7 3.3-3.1 4.4l-1.5-1.5a5 5 0 0 0-6.2-6.2L8.6 8.6C9.6 7.6 10.8 7 12 7Z"
      />
    </svg>
  );
}
